import { render } from "./WhyChooseUs.vue?vue&type=template&id=61c41af8&scoped=true&bindings={\"shop\":\"data\",\"counted\":\"data\",\"stats\":\"data\",\"animateCounts\":\"options\"}"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=61c41af8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61c41af8"

export default script